import type {
  ExternalSubject,
  ExternalSubjectEditPayload,
  FineUploaderUpload,
  StudentEditSubmissionDeleteExternalSubjectRequest,
} from './api'

export type ExternalSubjectModalFormState = {
  currentExternalSubject: Partial<ExternalSubject>
  externalSubjectCode: string
  externalSubjectName: string
  externalSubjectLevel: string
  externalSubjectYear: string
  externalSubjectUrl: string
}

export const externalSubjectCodePattern = /^[A-Za-z0-9]*$/

export function initialExternalSubjectModalFormState(
  subject: Partial<ExternalSubject>,
): ExternalSubjectModalFormState {
  return {
    currentExternalSubject: subject,
    externalSubjectCode: subject.external_subject_code ?? '',
    externalSubjectName: subject.external_subject_name ?? '',
    externalSubjectLevel: subject.external_subject_level == null ? '' : String(subject.external_subject_level),
    externalSubjectYear: subject.external_subject_year == null ? '' : String(subject.external_subject_year),
    externalSubjectUrl: subject.external_subject_url ?? '',
  }
}

export function externalSubjectCodeInputAllowed(inputText: string | null): boolean {
  return inputText == null || externalSubjectCodePattern.test(inputText)
}

export function buildExternalSubjectEditPayload(args: {
  existingSubject: Partial<ExternalSubject> | null
  externalCourseId: number
  deleteAttachmentIds: number[]
  newAttachments: FineUploaderUpload[]
  externalSubjectCode: string
  externalSubjectLevel: string
  externalSubjectName: string
  externalSubjectYear: string
  externalSubjectUrl: string
}): ExternalSubjectEditPayload {
  return {
    ...args.existingSubject,
    external_course_id: args.externalCourseId,
    delete_attachments: args.deleteAttachmentIds,
    new_attachments: args.newAttachments,
    external_subject_code: args.externalSubjectCode.toUpperCase(),
    external_subject_level: args.externalSubjectLevel,
    external_subject_name: args.externalSubjectName,
    external_subject_year: args.externalSubjectYear,
    external_subject_url: args.externalSubjectUrl,
  }
}

export function externalSubjectDeleteConfirmationMessage(subjectCode: string | undefined): string {
  return `Are you sure you want to remove the subject '${subjectCode}'?`
}

export function buildExternalSubjectDeleteRequest(
  secureData: string,
  externalSubjectId: number,
): StudentEditSubmissionDeleteExternalSubjectRequest {
  return {
    secure_data: secureData,
    delete_external_subject_id: externalSubjectId,
  }
}
